.body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--s5);
  padding: var(--s3) 0 var(--s2);
}

.row {
  display: flex;
  align-items: center;
  gap: var(--s4);
}

.value {
  min-width: 5ch;
  text-align: center;
  font-size: 2.5rem;
  line-height: 1;
}

.input {
  width: 100%;
  min-height: var(--target);
  padding: 0 var(--s4);
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: var(--r-readout);
  color: var(--ink);
  font-size: 1.25rem;
  text-align: center;
}
